module.exports = __webpack_public_path__ + "static/media/013.09f68c1e.jpg";